<template>
    <div>
        <el-row>
            <el-col :span="16">
                <div class="ch-select-box">
                    <div v-for="(item, index) in selectOption" :key="index" @click="onSelect(item, index)"
                        class="ch-select-item" :class="item.value == activeSelect ? 'active' : ''">
                        {{ item.label }}
                    </div>
                </div>
            </el-col>
            <el-col :span="8">
                <el-input clearable placeholder="请输入名称或关键字搜索" v-model="query.noticeTitle">
                    <el-button slot="append" @click="getData" type="primary" icon="el-icon-search">搜索</el-button>
                </el-input>
            </el-col>
        </el-row>
        <el-table v-loading="tableLoading" border :data="list" style="width: 100%; margin-top: 20px">
            <el-table-column v-if="false" label="公告ID" show-overflow-tooltip prop="noticeId"></el-table-column>
            <el-table-column label="采购名称" show-overflow-tooltip prop="noticeTitle">
                <template slot-scope="scope">
                    <el-link @click="onInfo(scope.row)" type="primary">
                        {{ scope.row.noticeTitle }}
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column :label="activeSelect == 1 ? '报名时间' : '拒绝时间'" show-overflow-tooltip prop="createTime"
                width="240px"></el-table-column>
            <!-- 参与响应的项目 -->
            <el-table-column v-if="activeSelect == 1" label="响应文件" show-overflow-tooltip prop="fileList">
                <template slot-scope="scope">
                    <el-link @click="
                        downloadfileUrl(scope.row.fileList.fileIdPath, scope.row.fileList.fileName)
                        " type="primary">
                        {{ scope.row.fileList.fileName }}</el-link>
                </template>
            </el-table-column>

            <!-- 未参与响应的项目 -->
            <el-table-column width="200px" v-if="activeSelect == 2" label="说明文件" show-overflow-tooltip prop="fileList">
                <template slot-scope="scope">
                    <el-link @click="downloadfileUrl(scope.row.reasonFile, scope.row.noticeTitle)"
                        type="primary">查看</el-link>
                </template>
            </el-table-column>

            <el-table-column v-if="activeSelect == 1" label="中标状态" prop="biddingStatus" width="120px">
                <template slot-scope="scope">
                    <template v-if="scope.row.resultType == 1">
                        <el-tag effect="dark" type="info" v-if="!scope.row.resultId">待定标</el-tag>
                        <el-tag effect="dark" type="warning" v-else-if="scope.row.isBidder == 0">未中标</el-tag>
                        <el-tag effect="dark" type="success" v-else-if="scope.row.isBidder == 1">已中标</el-tag>

                    </template>
                    <template v-if="scope.row.resultType == 2">
                        <el-tag effect="dark" type="danger">流标</el-tag>
                    </template>
                    <!-- <span v-else>待开标</span> -->
                </template>
            </el-table-column>

            <el-table-column v-if="activeSelect == 1" width="200px" label="报价金额" prop="quotedAmount">
                <template slot-scope="scope">
                    <span>
                        {{ formatCurrency(scope.row.quotedAmount) }}
                    </span>
                    <el-link @click="quotationModalShow(scope.row)"
                        v-if="scope.row.quoteFlag == 0 && scope.row.biddingStatus == 0" :underline="false"
                        type="primary" style="margin-left: 10px">
                        修改报价
                    </el-link>
                </template>
            </el-table-column>
            <!-- <el-table-column v-if="activeSelect == 1" label="下浮比例" prop="downwardFloatRate">
      <template slot-scope="scope">
        {{ scope.row.downwardFloatRate?scope.row.downwardFloatRate+'%':'' }}
      </template>
      </el-table-column> -->
            <!-- <el-table-column v-if="activeSelect == 1" label="最终报价" prop="finalPrice">
      </el-table-column> -->
            <el-table-column v-if="false" label="操作" width="40px">
                <template slot-scope="scope">
                    <div v-if="false" style="display: flex">
                        <el-button type="primary" v-if="
                            scope.row.preTrialState === 1 &&
                            scope.row.signNode === 2 &&
                            scope.row.signPreTrial === 1 &&
                            scope.row.tenderIfPay === 0
                        " size="mini" @click="openDialog(scope.row)">报名
                        </el-button>

                        <el-button type="primary" size="mini" @click="uploadFile(scope.row)"
                            v-if="scope.row.status == 3">
                            {{ scope.row.bidFile != null ? "修改投标信息" : "文件上传" }}
                        </el-button>
                        <el-button type="primary" size="mini" v-if="scope.row.auditStatus == 0">
                            报名审核中</el-button>
                        <el-button type="primary" size="mini"
                            v-if="scope.row.auditStatus > 0 && scope.row.auditReceiptStatus == -1"
                            @click="openDetailReceipt(scope.row)">
                            保证金
                        </el-button>
                        <el-button type="primary" size="mini"
                            v-if="scope.row.auditStatus > 0 && scope.row.auditReceiptStatus == 0" :disabled="true">
                            保证金审核中
                        </el-button>

                        <el-button type="primary" size="mini"
                            v-if="scope.row.auditStatus > 0 && scope.row.auditReceiptStatus == 2"
                            @click="openDetailReceipt(scope.row)">
                            保证金驳回,请重新上传
                        </el-button>
                        <el-button type="primary" size="mini" @click="openDetail(scope.row)">详情</el-button>
                        <!-- v-if="[4,6,7].includes(scope.row.biddingCode)" -->
                        <!--  v-if="[4,5,6,7].includes(scope.row.biddingCode-0) && scope.row.quotedFlag ==1"-->
                        <el-button type="primary" size="mini" @click="connectModalShow(scope.row, 1)" v-if="
                            scope.row.chatStatus == 1 &&
                            [4, 5, 6, 7].includes(scope.row.biddingCode - 0) &&
                            scope.row.quotedRound == 1 &&
                            scope.row.status == 4
                        ">
                            沟通
                        </el-button>

                        <el-button type="primary" size="mini" @click="connectModalShow(scope.row, 2)"
                            v-if="scope.row.clarificationStatus == 1">
                            澄清
                        </el-button>
                        <el-button v-if="
                            [4, 5, 6, 7].includes(scope.row.biddingCode - 0) &&
                            scope.row.quotedFlag == 1 &&
                            scope.row.bidFile
                        " type="primary" size="mini" @click="quotationModalShow(scope.row)">
                            {{ scope.row.quotedEnd == 0 ? "再次报价" : "最终报价" }}
                        </el-button>

                        <el-button v-if="[1, 2].includes(scope.row.biddingCode - 0) && scope.row.status >= 4"
                            type="primary" size="mini" @click="recordModalClick(scope.row)">
                            查看开标信息
                        </el-button>

                        <el-button size="mini" @click="contractModalClick(scope.row)" type="primary"
                            v-if="scope.row.biddingStatus == 1 && !scope.row.contractStatus">
                            合同上传
                        </el-button>

                        <el-button size="mini" @click="noticeModalClick(scope.row)" type="primary"
                            v-if="scope.row.biddingStatus == 1">
                            中标通知书
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,  prev, pager, next, jumper" :current-page="query.page" :page-sizes="[20, 50, 100]"
            :page-size="query.size" :total="total" />
        <el-dialog center title="提示" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
            <div class="ch-pay-box">
                <div style="text-align: center">
                    <el-image :src="url" style="width: 80px; height: 80px" />
                    <div style="color: #343434; font-size: 14px">收款二维码</div>
                </div>
                <div class="ch-pay-item">
                    <div class="ch-pay-item-price">报名费：{{ price }}</div>
                    <div class="ch-pay-item-desc">
                        请用支付宝/微信扫描上方二维码进行支付，支付成功后请上传付款截图。
                    </div>
                    <div class="ch-pay-img">
                        <el-input placeholder="付款截图" clearable v-model="payFileName" disabled />
                        <el-upload ref="payUpload" name="multipartFile" class="ch-upload-pay"
                            action="/system/file/upload" :file-list="payFileList" :on-success="onChange">
                            <el-button type="none" plain>上传文件</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()">提交</el-button>
            </span>
        </el-dialog>

        <el-dialog center title="项目详情" :visible.sync="detailDialogVisible" width="900px"
            :before-close="detailHandleClose">
            <div>
                <div class="ch-info-box">
                    <div class="ch-info-title">{{ detailList.projectName }}</div>
                    <div class="ch-info-title mark" v-if="isWinBid">已中标</div>
                    <div class="ch-info-tabel">
                        <!-- <div class="ch-into-item">
            <div class="ch-info-item-td ch-info-item-label">公告详情</div>
            <div class="ch-info-item-td ch-info-item-value"><span style="color: #109cee;text-decoration: underline;"
                @click="visible1 = true">查看公告详情</span></div>
          </div> -->
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">项目编号</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.projectCode }}
                            </div>
                        </div>
                        <div class="ch-into-item" v-if="false">
                            <div class="ch-info-item-td ch-info-item-label">项目公告地址</div>

                            <div class="ch-info-item-td ch-info-item-value">
                                <a :href="detailList.projectBulletinUrl">项目公告</a>
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">项目开标时间</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.saleTime }}
                            </div>
                        </div>
                        <div class="ch-into-item" v-if="false">
                            <div class="ch-info-item-td ch-info-item-label">开标地址</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.siteName }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">项目负责人</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.leaderName }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">项目负责人电话</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.leaderPhone }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">保证金</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.bondFormat }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">报名截止时间</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.enrollEnd }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">标书发售方式</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{
                                    detailList.biddingFileInfo != null
                                        ? detailList.biddingFileInfo.saleTypeName
                                        : ""
                                }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">是否有报名资格预审</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.prequalification == 0 ? "是" : "否" }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">上网及报名时间</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ detailList.enrollStart }} 至 {{ detailList.enrollEnd }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">状态</div>
                            <div class="ch-info-item-td ch-info-item-value">
                                {{ statusList[detailList.status] }}
                            </div>
                        </div>
                        <div class="ch-into-item">
                            <div class="ch-info-item-td ch-info-item-label">招标文件</div>
                            <div v-if="detailList.biddingFileStatus == 1 && detailList.status >= 2"
                                @click="dialogVisibleDownFileClick" class="ch-info-item-td ch-info-item-value"
                                style="color: #3984f7; cursor: pointer">
                                下载
                            </div>
                            <div v-else class="ch-info-item-td ch-info-item-value" style="color: #de4234">
                                暂无标书文件
                            </div>
                        </div>
                        <p style="margin-top: 30px; font-size: 20px" v-if="false">包件信息</p>
                        <el-table v-if="false" border :data="detailList.signUpPackageVoList" style="width: 100%">
                            <el-table-column prop="packageCode" label="包件编号" width="80">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="packageName" label="包件名称">
                            </el-table-column>
                            <el-table-column prop="preTrialState" :formatter="preTrialStateFormatter" width="100px"
                                label="预审状态">
                            </el-table-column>
                            <el-table-column prop="remark" width="100px" label="备注">
                            </el-table-column>
                            <el-table-column width="100px" label="付款截图">
                                <template slot-scope="scope">
                                    <img style="width: 50px; height: 50px" :src="scope.row.signPaymentScreenshot"
                                        alt="无数据" />
                                </template>
                            </el-table-column>
                            <el-table-column :formatter="signTypeFormatter" prop="signType" width="100px" label="报名方式">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip label="操作" v-if="detailList.signPreTrial == 1">
                                <template slot-scope="scope">
                                    <el-button @click="openEdit(scope.row.preTrialList)" size="mini"
                                        type="text">查看资料清单</el-button>
                                </template>
                            </el-table-column>
                        </el-table>

                        <p style="margin-top: 30px; font-size: 20px" v-if="detailList.tenderFileVos">
                            标书文件
                        </p>

                        <el-table border :data="detailList.tenderFileVos" style="width: 100%"
                            v-if="detailList.tenderFileVos">
                            <el-table-column show-overflow-tooltip prop="fileName" label="文件名称">
                            </el-table-column>
                            <el-table-column prop="upTime" label="上传时间"> </el-table-column>

                            <el-table-column show-overflow-tooltip label="操作">
                                <template slot-scope="scope">
                                    <el-button @click="downloadfile(scope.row)" size="mini" type="text">下载文件</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                        <!--<div>
                资格清单：
                <a :href="items.url" v-for="items in item.preTrialList"> {{items.name}}</a>
              </div>-->
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button >修改投标信息</el-button> -->
                <el-button @click="detailDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="资料清单" :visible.sync="listVisible" width="500px">
            <div v-for="(item, index) in preTrialList" style="height: 200px; overflow: auto" :key="index">
                <!-- <span @click="downloadurl(item.url)">{{item.name}}</span> -->
                <a :href="item.url">{{ item.name }}</a><br />
            </div>
            <span slot="footer" class="dialog-footer">
                <!-- <el-button @click="dialogVisible = false">取 消</el-button> -->
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 招标公告弹窗 -->
        <el-dialog title="公告详情" :visible.sync="visible1" width="80%">
            <div>
                <div class="ch-info-tabel">
                    <div class="ch-into-item">
                        <div class="ch-info-item-td ch-info-item-value" v-html="detailList.content"></div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible1 = false">取 消</el-button>
            </span>
        </el-dialog>

        <!-- 文件上传:on-change="(file, fileList) => uploadFileSuccess(file, fileList)" 
      @close="$refs['fileFrom'].resetFields(); fileList = []"-->
        <el-dialog title="标书文件上传" :visible.sync="fileVisible" width="950px">
            <el-form style="max-height: 45vh; overflow-y: auto" :model="fileFrom" ref="fileFrom" label-width="160px">
                <el-form-item label="" prop="bidFileList">
                    <!-- <el-button 
              type="primary" 
              @click="$CA.encFile(fileFrom.projectId)"
              style="margin-bottom: 10px;">
                标书文件签章
            </el-button> -->

                    <el-button type="primary" @click="getFile()" style="margin-bottom: 10px">
                        投标文件签章
                    </el-button>
                    <input style="height: 0; width: 0" type="file" id="fileInput" />
                    <el-button type="primary" @click="$CA.encFile(fileFrom.projectId)"
                        style="margin-bottom: 10px; margin-left: 10px">
                        投标文件加密
                    </el-button>
                    <div class="fileBox">
                        <div class="fileTitle">已加密文件路径</div>
                        <div class="fileItem">
                            <div v-for="(i, index) in fileStoreList" :key="index">{{ i.dstPath }}</div>
                        </div>
                    </div>
                    <!-- application/pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document -->
                    <el-upload :action="files" :headers="Authorization" :file-list="fileList" multiple
                        accept="application/pdf"
                        :on-success="(res, file, fileList) => uploadFileSuccess(res, file, fileList)"
                        :on-remove="onRemoveFile" :before-upload="beforeUpload">
                        <!-- <i class="el-icon-upload"></i>
            <div class="el-upload__text">将多个加密文件拖到此处，或<em>点击上传</em></div>
            <div class="el-upload__tip" slot="tip">只支持签章并加密后的PDF文件</div> -->
                        <el-button type="primary">加密文件上传</el-button>
                        <span slot="tip" style="margin-left: 10px; color: red">只支持签章并加密后的PDF文件</span>
                    </el-upload>
                </el-form-item>

                <el-form-item>
                    <div style="font-size: 16px; font-weight: 600" slot="label">投标联系人信息</div>
                </el-form-item>
                <el-form-item label="联系人姓名">
                    <el-input placeholder="请输入联系人姓名" v-model="fileFrom.contactName"></el-input>
                </el-form-item>

                <el-form-item label="联系人电话">
                    <el-input placeholder="请输入联系人电话" v-model="fileFrom.contactPhone"></el-input>
                </el-form-item>

                <el-form-item label="联系人邮箱">
                    <el-input placeholder="请输入联系人邮箱" v-model="fileFrom.contactEmail"></el-input>
                </el-form-item>
                <el-form-item>
                    <div style="font-size: 16px; font-weight: 600" slot="label">开标一览信息</div>
                    <span style="margin-left: 5px; color: red">开标一览信息内容填写与投标文件不一致时，按无效投标处理</span>
                </el-form-item>
                <!-- @input="fileFrom.price = fileFrom.price.replace(/[^0-9.]/g, '')" -->
                <el-form-item label="投标报价" prop="price">
                    <el-input placeholder="请输入投标文件填写的投标报价" v-model="fileFrom.price">
                    </el-input>
                </el-form-item>
                <el-form-item label="服务期/供货期/工期">
                    <el-input placeholder="请输入投标文件填写的服务期/供货期/工期" v-model="fileFrom.serverPeriod"></el-input>
                </el-form-item>

                <el-form-item label="质量要求">
                    <el-input placeholder="请输入投标文件填写的质量要求" v-model="fileFrom.qualityRequirement"></el-input>
                </el-form-item>

                <el-form-item>
                    <div style="font-size: 16px; font-weight: 600" slot="label">招标免责声明</div>
                </el-form-item>
                <div v-if="false" style="
            font-size: 20px;
            font-weight: 600;
            text-align: center;
            margin-bottom: 10px;
            text-decoration: underline;
          "></div>

                <el-form-item>
                    <div style="
              margin: 0 auto;
              font-size: 14px;
              line-height: 24px;
              padding: 15px;
              box-sizing: border-box;
              border: 1px solid #ccc;
            ">
                        尊敬的投标者:<br />

                        感谢您对我们项目的关注。然而，由于各种原因(包括但不限于数据输入错误、信息更新不及时等)，公告中可能存在一些错误或遗漏。在参与本项目的招标过程中，请您仔细阅读以下免责声明，确保您充分理解并接受其中的内容。投标者在使用公告信息时，应自行核实其准确性，并承担因信息不准确或不完整而可能产生的风险。<br />

                        信息准确性:我们尽力确保招标公告中的信息准确无误。然而，由于各种不可预见的情况，我们可能无法及时更新或更正公告中的信息。风险自担:投标者参与本次招标项目，应充分了解项目相关情况，自行评估潜在风险，并自行承担由此产生的一切后果。投标者在使用公告信息时，应自行核实其准确性，并承担因信息不准确或遗漏而产生的风险。招标方不承担任何因投标者误判风险或操作失误而造成的损失。投标风险:投标者参与本项目的投标，应自行评估风险和可行性法律责任:投标者应确保所提交的所有文件和信息真实、合法、有效。我们对投标者因参与投标而产生的任何失或损害不承担任何责任。如因投标者提供虚假信息或违反法律法规而导致任何纠纷或损失，投标者应承担全部法律责任。知识产权:招标公告中可能包含受版权、商标权或其他知识产权法律保护的材料。免责声明:招标方对于因不可抗力、政府政策调整、市场变化等非招标方所能控制的因素导致的招标投标者在使用这些材料时，应遵守相关的法律法规，未经授权不得进行复制、传播或用于其他商业用途。活动中断、变更或取消，不承担任何责任。投标者应自行承担由此产生的任何损失。<br />

                        保密义务:投标者在参与投标过程中，可能接触到我们的商业机密或敏感信息争议解决:如因本次招标活动产生任何争议，双方应首先友好协商解决;投标者应严格遵守保密义务，未经我们明确书面同意，不得将相关信息泄露任何第三方。协商不成的，可提交至有管辖权的人民法院诉讼解决。招标结果:我们保留对招标结果的最终解释权。请您在参与本次招标活动时，务必仔细阅读并遵守以上免责声明事项。如有任何疑问或需要进一步了解的信息，请及时与我们联系。感谢您的理解与支持!在决定中标者时，我们将综合考虑投标者的报价、技术实力、信誉等因素。
                    </div>
                </el-form-item>

                <div style="width: 80%; margin: 0 auto; margin-top: 30px">
                    <el-checkbox v-model="checked">
                        我已阅读并同意“投标免责声明”内容并上传投标文件
                    </el-checkbox>
                </div>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="fileVisible = false">取 消</el-button>
                <el-button v-loading="fileVisibleLoading" type="primary" @click="submitInfo">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 沟通弹窗 -->
        <el-dialog center title="沟通" :visible.sync="connectModal" width="900px" :before-close="detailHandleClose">
            <!-- @tab-click="handleClick" -->
            <el-tabs v-if="false" type="card" v-model="activeSpecialUserId" @tab-click="handleClick">
                <el-tab-pane v-for="(item, index) in specialList" :label="item.specialUserName"
                    :name="item.specialUserId">
                    <span slot="label">
                        {{ item.specialUserName }}
                        <!-- v-if="item.flag" -->
                        <!-- style="display:inline;font-size: 6px; color: red;padding:0px 4px;background: red;border-radius: 100%;" -->
                        <sup v-if="item.flag" style="margin-left: 3px; color: red">
                            {{ item.flag }}
                        </sup>
                    </span>
                </el-tab-pane>
            </el-tabs>

            <div ref="connectRef" class="connectClass">
                <div class="father">
                    <div v-for="(item, index) in chatList" :key="item.id" class="connectItem" :style="{
                        float: item.msgType == 2 ? 'left' : 'right',
                        'text-align': item.msgType == 1 ? 'left' : 'right',
                    }">
                        <div style="padding-bottom: 5px">
                            {{ item.senderName }} {{ item.createTime }}
                        </div>
                        <div :class="['infoClass', item.msgType == 1 ? 'backgroundEdeded' : '']">
                            <span style="text-align: left !important ; float: left">
                                {{ item.content }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <el-input type="textarea" style="box-shadow: 15px 0px 10px -15px #ccc"
                :autosize="{ minRows: 2, maxRows: 4 }" placeholder="请输入内容" v-model="chatSaveObj.content">
            </el-input>
            <div slot="footer" class="dialog-footer">
                <el-button @click="connectModal = false">取 消</el-button>
                <el-button type="primary" @click="okChatSave">发送</el-button>
            </div>
        </el-dialog>

        <!-- 再次报价  /修改报价 -->
        <el-dialog center title="修改报价" :visible.sync="quotationModal" width="500px" :before-close="detailHandleClose">
            <div>
                <p>报价金额</p>
                <el-input v-model="secondPriceObj.quotedAmount" @input="
                    secondPriceObj.quotedAmount = secondPriceObj.quotedAmount.replace(
                        /[^0-9.]/g,
                        ''
                    )
                    " type="text" placeholder="请输入金额"></el-input>
            </div>

            <div>
                <p>响应文件</p>
                <el-upload :action="actionUrl" :on-preview="handlePictureCardPreview" :on-remove="handleRemove"
                    :file-list="fileList" :on-success="(response, file, fileList) => onSuccess(response, file, fileList, 6)
                        ">
                    <el-button type="primary">响应文件上传</el-button>
                </el-upload>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="quotationModal = false">取 消</el-button>
                <el-button type="primary" @click="okSecondPriceSave">提交</el-button>
            </div>
        </el-dialog>

        <!-- 报价列表 -->
        <el-dialog center title="报价列表" :visible.sync="moreQuotesModal" width="900px" :before-close="detailHandleClose">
            <el-table border :data="moreQuotesList" style="width: 100%">
                <el-table-column label="报价" show-overflow-tooltip prop="quotedAmount"></el-table-column>
                <el-table-column label="时间" show-overflow-tooltip prop="createTime"></el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="moreQuotesModal = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 评标记录 -->
        <el-dialog center title="开标信息" :visible.sync="recordModal" width="900px" :before-close="detailHandleClose">
            <div>
                <p>
                    <span>项目名称：</span>
                    <span>{{ recordObj.resData.projectName }}</span>
                </p>
                <p>
                    <span>项目编号：</span>
                    <span>{{ recordObj.resData.projectCode }}</span>
                </p>
                <p>
                    <span>开标时间/比选时间：</span>
                    <span>{{ recordObj.resData.biddingDate }}</span>
                </p>
            </div>
            <el-table border :data="recordObj.resData.supplierList" style="width: 100%">
                <el-table-column label="序号" show-overflow-tooltip prop="index"></el-table-column>
                <el-table-column label="供应商名称" show-overflow-tooltip prop="supplierName"></el-table-column>
                <el-table-column label="报价" show-overflow-tooltip prop="quotedPrice"></el-table-column>
                <el-table-column label="服务期/供货期/工期" show-overflow-tooltip prop="serverPeriod"></el-table-column>
                <el-table-column label="质量要求" show-overflow-tooltip prop="qualityRequirement"></el-table-column>
                <!-- <el-table-column :label="recordObj.custom" show-overflow-tooltip prop="custom"></el-table-column> -->
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="recordModal = false">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 合同 -->
        <el-dialog center title="合同" :visible.sync="contractModal" width="900px" :before-close="detailHandleClose">
            <el-upload :file-list="contractFileList" :action="files" :headers="Authorization" :on-remove="handleRemove"
                :on-success="(res, file, fileList) => uploadContractSuccess(res, file, fileList, 1)
                    " :limit="1">
                <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>

            <span slot="footer" class="dialog-footer">
                <el-button @click="contractModal = false">取 消</el-button>
                <el-button v-loading="fileVisibleLoading" type="primary" @click="contractSave">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 通知书 -->
        <el-dialog center title="中标通知书" :visible.sync="noticeModal" width="900px" :before-close="detailHandleClose">
            <el-link :underline="false" type="primary">{{ noticeModalObj.fileName }}</el-link>
            <el-button type="success" style="margin-left: 20px" size="small"
                @click="downFileClick(noticeModalObj.filePath, noticeModalObj.fileName)">
                查看
            </el-button>
        </el-dialog>

        <!--保证金  -->
        <el-dialog center title="保证金" :visible.sync="receiptModal" width="1000px">
            <div>
                <div class="receiptClass">
                    <div class="laberlTitle">开户行</div>
                    <div class="infoClass">{{ bondInfoObj.bankName }}</div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">开户名</div>
                    <div class="infoClass">{{ bondInfoObj.name }}</div>
                </div>
                <div class="receiptClass">
                    <div class="laberlTitle">银联支付账号</div>
                    <div class="infoClass">{{ bondInfoObj.unionPay }}</div>
                </div>
                <!-- <div class="receiptClass">
          <div class="laberlTitle">保证金金额</div>
          <div class="infoClass">{{projectInfo.bond}}</div>
        </div> -->

                <div class="receiptClass">
                    <div class="laberlTitle">微信收款码</div>
                    <div class="infoClass">
                        <el-image style="width: 60px" :src="bondInfoObj.imgWechatFileUrl"
                            :preview-src-list="[bondInfoObj.imgWechatFileUrl]">
                        </el-image>
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">支付宝收款码</div>
                    <div class="infoClass">
                        <el-image style="width: 60px" :src="bondInfoObj.imgAlipayFileUrl"
                            :preview-src-list="[bondInfoObj.imgAlipayFileUrl]">
                        </el-image>
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">缴纳时间</div>
                    <div class="infoClass">
                        {{ bondInfoObj.startTime }}至{{ bondInfoObj.endTime }}
                    </div>
                </div>

                <div class="receiptClass">
                    <div class="laberlTitle">保证金支付凭证/保函/保单</div>
                    <div class="infoClass">
                        <el-upload :file-list="receiptFileList" :action="files" :headers="Authorization"
                            :on-remove="handleRemove" :on-success="(res, file, fileList) => uploadContractSuccess(res, file, fileList, 2)
                                " :limit="1">
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="receiptModal = false">取 消</el-button>
                <el-button v-loading="fileVisibleLoading" type="primary" @click="receiptSave">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import announcement from "@/api/announcement/announcement";
import req from "@/api/config/config";
import socketApi from "@/utils/socket.js";
export default {
    created() {
        socketApi.initWebSocket(this.getMasg);
        this.getData();
        this.Authorization = {
            "BIDDING-SOURCE": "PC",
            OID: JSON.parse(localStorage.getItem("orgInfo"))?.oid || "",
            Authorization:
                "Bearer " + `${JSON.parse(localStorage.getItem("userInfo"))?.access_token || ""}`,
        };
    },
    data() {
        return {
            receiptModal: false,
            checked: false,
            receiptObj: {
                projectId: "",
                payFile: "",
            },
            bondInfoObj: {},
            receiptFileList: [],
            noticeModal: false,
            noticeModalObj: {},
            contractModal: false,
            contractObj: {
                projectId: "",
                fileId: "",
            },
            contractFileList: [],
            recordModal: false,
            recordObj: {
                custom: "",
                resData: {},
            },
            fileVisible: false,
            fileVisibleLoading: false,
            fileFrom: {
                bidFileList: [],
                price: "",
                projectId: "",
            },
            tableLoading: false,
            fileObj: {
                dstPath: "",
                encKey: "",
            },

            fileList: [],
            fileStore: [],

            Authorization: "",
            // files:
            //   `${req.systemIp}/pc/project/bid/file/upload`,
            files: req.systemIp + "/sysFileInfo/upload",
            actionUrl: req.systemIp + "/sysFileInfo/upload",
            uploadData: {},
            visible1: false,
            statusList: {
                0: "流标",
                1: "已发布",
                2: "报名中",
                3: "待开标",
                4: "待确定中标",
                5: "待出结果公告",
                6: "待出中标通知",
                7: "完成",
            },
            isWinBid: false,
            activeSelect: "1",
            selectOption: [
                {
                    label: "已响应",
                    value: 1,
                },
                {
                    label: "未响应",
                    value: 2,
                },
            ],
            keyword: undefined,
            list: [],
            total: null,
            query: {
                page: 1,
                size: 10,
                responseStatus: 1,
                keyword: null, //项目名称
            },
            // 报名
            dialogVisible: false,
            detailDialogVisible: false,
            payFileList: [],
            price: 0,
            payFileName: "",
            submitData: {},
            url: "",
            preTrialList: [],
            detailList: {
                biddingFileInfo: {},
            },
            listVisible: false,
            detaiInfo: {},
            fileStoreList: [],
            connectModal: false,
            chatSaveObj: {}, //消息保存
            chatPageObj: {
                limit: 10,
                page: 1,
            }, //消息获取
            chatList: [],
            chatListTotal: [],
            activeSpecialUserId: "", //点击的专家
            specialList: [], //专家列表
            quotationModal: false, //报价弹窗
            secondPriceObj: {
                id: "",
                // secondPrice: ''
                quotedAmount: "",
                fileId: "",
            },
            moreQuotesModal: false,
            moreQuotesList: [], //报价列表
            nowFileList: [],
        };
    },
    mounted() {
        this.getData();
        window.addEventListener("setItemEvent", (e) => {
            // 监听setitem的 key ，执行对应的业务逻辑
            this.fileStoreList = [];
            this.fileStoreList = JSON.parse(e.value);
            console.log(e.key, this.fileStoreList);
        });
    },
    beforeDestroy() {
        console.log("组件卸载前");
        // socketApi.closeWebSocket()
    },
    methods: {
        handlePictureCardPreview() { },
        onSuccess(response, file, fileList, index) {
            if (index == 6) {
                this.secondPriceObj.fileId = response.data.fileId;
            }
        },
        onInfo(row) {
            let routeData = this.$router.resolve({
                path: "/purchase/info",
                query: {
                    noticeId: row.noticeId,
                    projectId: row.projectId,
                    type: 6,
                    id: row.noticeId,
                },
            });
            window.open(routeData.href, "_blank");
        },
        formatCurrency(amount) {
            return new Intl.NumberFormat("zh-CN", {
                style: "currency",
                currency: "CNY",
            }).format(amount);
        },
        // 根据URL下载文件
        downloadfileUrl(path, fileName) {
            var a = document.createElement("a");
            a.href = path;
            console.log(fileName);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        async getFile() {
            this.$CA.encFileBefore();
        },
        openDetailReceipt(row) {
            this.receiptFileList = [];
            this.receiptModal = true;
            this.bondInfo(row.projectId);
            this.receiptObj.projectId = row.projectId;
        },
        receiptSave() {
            announcement.receipt(this.receiptObj).then((res) => {
                if (res.code == 0) {
                    this.receiptFileList = [];
                    this.receiptModal = false;
                    this.$message.success("上传成功");
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        bondInfo(dataId) {
            announcement.bondInfo(dataId).then((res) => {
                if (res.code == 0) {
                    this.bondInfoObj = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        downFileClick(url, name) {
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = url;
            link.setAttribute("download", name);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },
        noticeModalClick(rowData) {
            announcement.notice({ projectId: rowData.projectId }).then((res) => {
                if (res.code == 0) {
                    this.noticeModalObj = res.data;
                    this.noticeModal = true;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        contractModalClick(rowData) {
            this.contractObj.projectId = rowData.projectId;
            this.contractFileList = [];
            this.contractModal = true;
        },
        uploadContractSuccess(res, file, fileList, index) {
            if (res?.data?.fileId) {
                if (index == 1) {
                    //合同
                    this.contractObj.fileId = res.data.fileId;
                }
                if (index == 2) {
                    //保证金上传
                    this.receiptObj.payFile = res.data.fileId;
                }
            } else {
                this.contractFileList = [];
                this.$message.error("登录已过期，请刷新页面后重新登录");
                // localStorage.clear();
                localStorage.removeItem("userInfo");
                localStorage.removeItem("orgInfo");
                setTimeout(function () {
                    location.href = "#/choice";
                }, 1000);
            }
        },
        contractSave() {
            if (!this.contractObj.fileId) {
                this.$message.error("请上传文件");
                return;
            }
            announcement.contractSave(this.contractObj).then((res) => {
                if (res.code == 0) {
                    this.$message.success(res.message);
                    this.contractModal = false;
                    this.contractFileList = [];
                    this.getData();
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        handleRemove() {
            this.contractObj.fileId = "";
        },
        recordModalClick(row) {
            announcement.bidRecord({ projectId: row.projectId }).then((res) => {
                console.log("评标记录", res);
                let bidRecordJson = {};
                if (JSON.parse(res.data.bidRecordJson)) {
                    bidRecordJson = JSON.parse(res.data.bidRecordJson) ?? {};
                    if (bidRecordJson.custom) {
                        this.recordObj.custom = bidRecordJson.custom;
                    }

                    res.data.supplierList.forEach((item, index) => {
                        const supplierObj = bidRecordJson.supplierList.filter((supplier) => {
                            return supplier.supplierId == item.supplierId;
                        })[0];
                        item.index = index + 1;
                        item.serviceTime = supplierObj.serviceTime;
                        item.serviceLocation = supplierObj.serviceLocation;
                        item.custom = supplierObj.custom;
                    });
                } else {
                    res.data.supplierList.forEach((item, index) => {
                        item.index = index + 1;
                        item.serviceTime = "";
                        item.serviceLocation = "";
                        item.custom = "";
                    });
                }
                this.recordObj.resData = res.data;
                this.recordModal = true;
            });
        },
        moreQuotesClick(row) {
            announcement.quotedList({ projectId: row.projectId }).then((res) => {
                this.moreQuotesList = res.data;
            });
            this.moreQuotesModal = true;
        },

        //报价弹窗
        quotationModalShow(row) {
            this.secondPriceObj.id = row.id;
            this.quotationModal = true;
        },
        okSecondPriceSave() {

            if (!this.secondPriceObj.quotedAmount) {
                this.$message.error("请输入报价");
                return;
            }

            if (!this.secondPriceObj.fileId) {
                this.$message.error("请上传响应文件");
                return;
            }
            announcement
                .updateQuote(this.secondPriceObj)
                .then((res) => {
                    if (res.code == 0) {
                        this.$message.success("修改报价成功");
                        this.quotationModal = false;
                        this.getData();
                    } else {
                        this.$message.error(res.message);
                    }
                })
                .catch((error) => {
                    console.log("错误", res);
                });
        },
        debounce(handle, delay) {
            let timer = null;
            return function () {
                let _self = this,
                    _args = arguments;
                clearTimeout(timer);
                timer = setTimeout(function () {
                    handle.apply(_self, _args);
                }, delay);
            };
        },

        handlerNodeScroll() {
            let debounceFunc = this.debounce((e) => {
                // 距顶部
                // console.log('ffffffffffff');
                let scrollTop = e.target.scrollTop;
                // 可视区高度
                let clientHeight = e.target.clientHeight;
                // 滚动条总高度
                let scrollHeight = e.target.scrollHeight;
                // 如果当前距离顶部的值加上可视区域的值大于等于总高度，则任务滚动条触底
                if (Math.ceil(scrollTop + clientHeight) >= scrollHeight) {
                    //容差：20px
                    console.log("滚动到底部");
                    if (this.chatPageObj.page * this.chatPageObj.limit <= this.chatListTotal) {
                        this.chatPageObj.page++;
                        this.getChatPage();
                    }
                }
            }, 500);

            // 监听滚动
            console.log("节点", this.$refs.connectRef);
            this.$refs.connectRef.addEventListener("scroll", (e) => {
                debounceFunc(e);
            });
        },
        handleClick() {
            this.specialList.forEach((item) => {
                if (item.specialUserId == this.activeSpecialUserId) {
                    item.flag = 0;
                }
            });
            this.chatPageObj.page = 1;
            this.chatList = [];
            this.chatListTotal = 0;
            this.getChatPage();
        },

        connectModalShow(record, index) {
            console.log("获取到的数据u", record);
            this.chatPageObj.type = index;
            this.chatSaveObj.type = index;
            this.chatSaveObj.projectId = record.projectId;
            this.chatPageObj.projectId = record.projectId;

            // socketApi.initWebSocket(getMasg)
            // nextTick(()=>{
            //     handlerNodeScroll()
            // })
            this.chatPageObj.page = 1;
            this.chatPageObj.limit = 999999;
            this.chatList = [];
            this.chatListTotal = 0;
            announcement.specialist({ projectId: record.projectId }).then((res) => {
                console.log("获取到的专家列表", res);
                this.specialList = res.data;
                // this.activeSpecialUserId=this.specialList[0].specialUserId
                this.activeSpecialUserId = "";
                this.getChatPage();
                this.connectModal = true;
                this.$nextTick(() => {
                    this.handlerNodeScroll();
                });
            });
        },
        //获取ws消息
        getMasg(data) {
            //senderId 1722529683107577858 receiverId 1721787778426822657 type
            let dataJson = JSON.parse(data);
            console.log("ggggggg", dataJson);
            if (dataJson.type == 1) {
                this.specialList.forEach((item) => {
                    if (item.specialUserId == dataJson.senderId) {
                        item.flag++;
                    }
                });
                this.$notify({
                    title: "你有新的沟通消息",
                    message: "你有新的沟通消息",
                    onClick: () => {
                        this.chatPageObj.page = 1;
                        this.chatList = [];
                        this.chatListTotal = 0;
                        this.chatPageObj.projectId = dataJson.projectId;
                        this.chatSaveObj.projectId = dataJson.projectId;
                        this.connectModal = true;
                        this.$nextTick(() => {
                            this.handlerNodeScroll();
                        });
                        this.getChatPage();
                    },
                });
                this.getChatPage(1);
            }
        },
        //获取消息列表
        getChatPage(index) {
            this.chatPageObj.specialistUserId = this.activeSpecialUserId;
            if (index == 1) {
                //代表发送消息后接收消息
                this.chatPageObj.page == this.chatPageObj.page - 1;
                this.chatPageObj.limit = 10;
            }
            announcement.chatPage(this.chatPageObj).then((res) => {
                console.log("获取消息列表", res);
                if (index == 1) {
                    this.chatList = this.chatList.slice(
                        0,
                        (this.chatPageObj.page - 1) * this.chatPageObj.limit
                    );
                }
                this.chatList = this.chatList.concat(res.data.list);
                this.chatListTotal = res.data.count;
                if (index != 1) {
                    //首次进来
                    this.chatPageObj.page = Math.ceil(res.data.count / 10);
                }
                setTimeout(() => {
                    this.$refs.connectRef.scrollTop = this.$refs.connectRef.scrollHeight;
                }, 500);
            });
        },
        //发送消息
        okChatSave() {
            // console.log("gggggggggggggggggg",(this.chatSaveObj.content.trim())=='')
            // return

            if (!this.chatSaveObj.content || this.chatSaveObj.content.trim() == "") {
                this.$message({
                    showClose: true,
                    message: "请输入消息内容",
                    type: "warning",
                });
                return;
            }
            this.chatSaveObj.specialistUserId = this.activeSpecialUserId;
            announcement.chatSave(this.chatSaveObj).then((res) => {
                this.chatSaveObj.content = "";
                this.getChatPage(1);
            });
        },
        // 监控locaStorage
        watchStorage() {
            const that = this;
        },
        dialogVisibleDownFileClick() {
            let link = document.createElement("a");
            link.style.display = "none";
            link.href = this.detailList.biddingFileInfo.filePath;
            link.setAttribute("download", this.detailList.biddingFileInfo.fileName);
            document.body.appendChild(link);
            link.click();
            link.remove();
        },

        downloadfile(row) {
            var a = document.createElement("a");
            // 获取文件名fileName
            let index = row.fileUrl.lastIndexOf("\.");
            let str = row.fileUrl;
            let str1 = str.substring(index);
            let fileName = row.fileName + str1;
            a.href = row.fileUrl;
            console.log(fileName);
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        },
        onSelect(item) {
            this.activeSelect = item.value;
            this.query.responseStatus = item.value;
            this.getData();
        },
        getData() {
            this.tableLoading = true;
            announcement.queryMyProjectSignListV2(this.query).then((res) => {
                this.list = res.data.list;
                this.total = res.data.count;
                this.tableLoading = false;
            });
        },
        goDetail(row) {
            console.log(row);
        },
        preTrialStateFormatter(row) {
            if (row.preTrialState == 0) {
                return "待审核";
            } else if (row.preTrialState == 1) {
                if (row.tenderIfPay == 2) {
                    return "审核通过";
                } else {
                    return "审核中";
                }
            } else if (row.preTrialState == 2) {
                return "驳回";
            } else {
                return "-";
            }
        },
        openDialog(row) {
            this.dialogVisible = true;
            this.submitData.projectSignId = row.id;
            this.url = row.collectionCode;
            this.price = row.packagePrice;
            this.payFileName = "";
        },
        openDetail(row) {
            this.detaiInfo = { ...row };
            console.log("项目详情", row);
            // if(row.isWinBid == 1){
            //   this.isWinBid = true
            // }
            this.detailDialogVisible = true;
            announcement
                .projectDetail({
                    projectId: row.projectId,
                })
                .then((res) => {
                    console.log(res.data);
                    this.detailList = res.data;
                });
        },
        onRemoveFile(file) {
            this.fileFrom.bidFileList.map((item, index) => {
                if ((item.fileId = file.fileId)) {
                    this.fileFrom.bidFileList.splice(index, 1);
                }
            });
        },
        open() {
            this.$confirm("当前账还未绑定CA证书,是否立即办理认证？", "提示", {
                confirmButtonText: "办理",
                cancelButtonText: "暂不",
                type: "warning",
                center: true,
            })
                .then(() => {
                    // this.$message({
                    //   type: 'success',
                    //   message: '删除成功!'
                    // });
                    this.$router.push("/CAtransact");
                })
                .catch(() => { })
                .finally(() => {
                    return;
                });
        },

        // 上传招标文件
        uploadFile(row) {
            const userInfo = JSON.parse(localStorage.getItem("userInfo"));
            if (!userInfo.ifLock) {
                // this.open()
                return;
            }
            if (!this.$CA.getSignCertInfo()) {
                this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                return false;
            }

            if (row.bidFile == 1) {
                this.fileFrom = row;
                this.fileFrom.projectId = row.projectId;
                this.fileStoreList = [];
                this.fileFrom.bidFileList = [];
                this.fileList = [];
                this.fileVisible = true;
                this.$set(this.fileFrom, "price", row.quotedPrice);

                row.bidFileList.map((obj) => {
                    this.fileList.push({
                        name: obj.fileName,
                        fileId: obj.fileId,
                        status: "success",
                        encKey: obj.encKey,
                    });
                    this.fileFrom.bidFileList.push({
                        fileId: obj.fileId,
                        encKey: obj.encKey,
                    });
                });
                // this.fileFrom.bidFileList.push({
                //     fileId: nowBidFileList[].fileId,
                //     encKey: result[0].encKey
                //   })
            } else {
                this.fileFrom.projectId = "";
                this.fileStoreList = [];
                this.fileVisible = true;
                this.fileFrom.projectId = row.projectId;
                this.fileFrom.bidFileList = [];
                console.log("11111", this.fileFrom.projectId);
            }
            if (JSON.parse(localStorage.getItem(`file_${this.fileFrom.projectId}`)) != null) {
                this.fileStoreList = JSON.parse(
                    localStorage.getItem(`file_${this.fileFrom.projectId}`)
                );
            }
        },
        // 成功上传招标文件
        uploadFileSuccess(res, file, fileList) {
            console.log(res, "456789");
            let fileStoreList = JSON.parse(
                localStorage.getItem(`file_${this.fileFrom.projectId}`)
            );
            let result = fileStoreList.filter((element) => {
                return element.dstName == file.name;
            });
            if (result.length != 0) {
                this.fileFrom.bidFileList.push({
                    fileId: res.data.fileId,
                    encKey: result[0].encKey,
                });
            }
            console.log(
                "res, file, fileList, item",
                res,
                file,
                fileList,
                this.fileFrom.bidFileList
            );
        },
        beforeUpload(file) {
            if (!this.$CA.getSignCertInfo()) {
                this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                return false;
            } else {
                if (file.name.indexOf("_已加密") != -1) {
                    let fileStore = JSON.parse(
                        localStorage.getItem(`file_${this.fileFrom.projectId}`)
                    );
                    if (fileStore != null) {
                        let result = fileStore.filter((el) => {
                            return el.dstName == file.name;
                        });
                        if (result.length == 0) {
                            this.$message.warning(
                                "该项目未绑定该加密标书文件，请删除已加密文件，重新加密源文件加密后再上传"
                            );
                            return false;
                        }
                    } else {
                        this.$message.warning("该项目未存在加密标书文件，请加密后再上传");
                        return false;
                    }
                } else {
                    this.$message.warning("请选择加密标书文件");
                    return false;
                }
            }
        },
        // 提交表单
        submitInfo() {
            if (!this.$CA.getSignCertInfo()) {
                this.$message.warning("未安装数字证书，或未找到符合License的数字证书");
                return false;
            }
            announcement
                .checkCa({ caSerialNumber: this.$CA.getSignCertInfo() })
                .then((res) => {
                    // console.log("RRRRRRRRRRRRRRRRR",res)

                    // res.code==0
                    if (res.code == 0) {
                        if (!this.checked) {
                            this.$message.error("请同意投标免责声明");
                            return;
                        }
                        if (this.fileFrom.bidFileList.length == 0) {
                            this.$message.error("请选择至少一个加密标书文件");
                            return;
                        }
                        if (parseFloat(this.fileFrom.price).toString() == "NaN") {
                            this.$message.error("请正确填写报价");
                            return;
                        }
                        if (!this.fileFrom.contactName?.trim()) {
                            this.$message.error("请输入联系人");
                            return;
                        }
                        if (!this.fileFrom.contactPhone?.trim()) {
                            this.$message.error("请输入联系人电话");
                            return;
                        }
                        if (!this.fileFrom.contactEmail?.trim()) {
                            this.$message.error("请输入联系人邮箱");
                            return;
                        }

                        if (!this.fileFrom.serverPeriod?.trim()) {
                            this.$message.error("请输入服务期/供货期/工期");
                            return;
                        }
                        if (!this.fileFrom.qualityRequirement?.trim()) {
                            this.$message.error("请输入质量要求");
                            return;
                        }

                        this.fileVisibleLoading = true;
                        announcement.uploadFile(this.fileFrom).then((res) => {
                            if (res.code == 0) {
                                this.fileVisible = false;
                                this.fileVisibleLoading = false;
                                this.getData();
                                this.$message.success(res.message);
                            } else {
                                this.fileVisibleLoading = false;
                                this.$message.error(res.message);
                            }
                        });
                    } else {
                        this.fileVisibleLoading = false;
                        this.$message.error(res.message);
                    }
                })
                .catch((error) => {
                    this.fileVisibleLoading = false;
                });
        },
        handleClose() {
            this.dialogVisible = false;
        },
        detailHandleClose() {
            this.noticeModal = false;
            this.contractModal = false;
            this.recordModal = false;
            this.moreQuotesModal = false;
            this.quotationModal = false;
            this.connectModal = false;
            this.detailDialogVisible = false;
            this.detaiInfo = {};
        },
        submit() {
            console.log(this.submitData);
            if (this.submitData.signPaymentScreenshot) {
                announcement.paySignUpFee(this.submitData).then((res) => {
                    if (res.code === 200) {
                        this.getData();
                        this.dialogVisible = false;
                        this.$message.success("报名成功");
                    }
                });
            } else {
                this.$message.warning("请上传付款截图");
            }
        },
        onChange(file, fileList) {
            console.log("fileList", fileList);
            if (fileList.status === "success") {
                this.payFileList = [fileList];
                this.payFileName = fileList.name;
                this.submitData.signPaymentScreenshot = fileList.response.data;
            } else {
                this.$message.warning("上传失败，请稍后再试");
            }
        },
        handleSizeChange(val) {
            this.query.size = val;
            this.getData();
        },
        handleCurrentChange(val) {
            this.query.page = val;
            this.getData();
        },
        signTypeFormatter(row) {
            if (row.signType === 1) {
                return " 线上报名 ";
            } else if (row.signType === 2) {
                return "线下报名 ";
            }
        },
        openEdit(data) {
            this.listVisible = true;
            this.preTrialList = JSON.parse(data);
            console.log(this.preTrialList);
        },
    },
};
</script>

<style lang="less" scoped>
.receiptClass {
    display: flex;
    border-bottom: 1px solid #ffffff;
    font-size: 16px;

    .laberlTitle {
        width: 20%;
        text-align: right;
        padding: 10px;
        background: #eee;
    }

    .infoClass {
        padding: 10px;
        background: #fafafa;
        flex: 1;
    }
}

.ch-container {
    width: 1400px !important;
}

.ch-select-box {
    display: flex;
    align-items: center;

    >.ch-select-item {
        padding: 5px 10px;
        font-size: 15px;
        color: #999999;
        cursor: pointer;
    }

    >.ch-select-item+.ch-select-item {
        border-left: 1px solid #efefef;
    }

    .ch-select-item.active {
        color: #3984f7;
    }
}

.el-pagination {
    text-align: center;
    margin-top: 20px;
}

.ch-info-box {
    width: 800px;
    padding: 25px 0;
    margin: auto;
}

.ch-info-title {
    font-size: 24px;
    font-weight: 400;
    color: #666666;
    line-height: 42px;
    margin-bottom: 35px;
    text-align: center;
}

.mark {
    color: #67c23a;
    text-align: center;
    line-height: 42px;
    font-weight: 400;
    font-size: 18px;
    margin-bottom: 20px;
}

.ch-info-tabel {
    border: solid 1px #efefef;
}

.ch-into-item {
    display: flex;

    >.ch-info-item-td {
        padding: 20px 30px;
        box-sizing: border-box;
    }

    >.ch-info-item-td+.ch-info-item-td {
        border-left: solid 1px #efefef;
    }
}

.ch-info-item-label {
    background-color: #f9f9f9;
    font-size: 14px;
    width: 160px;
    color: #343434;
}

.ch-info-item-value {
    font-size: 14px;
    color: #343434;
    flex: 1;
}

.ch-into-item+.ch-into-item {
    border-top: solid 1px #efefef;
}

.ch-pay-box {
    display: flex;
}

.ch-pay-item {
    margin-left: 20px;

    .ch-pay-item-price {
        font-size: 18px;
        font-weight: bold;
        color: #343434;
    }

    .ch-pay-item-desc {
        font-size: 14px;
        font-weight: 300;
        color: #343434;
    }
}

.ch-upload-pay {
    display: flex;

    /deep/ .el-upload-list {
        display: none;
    }
}

.ch-pay-img {
    margin-top: 20px;
    display: flex;
}

.ch-info-buttons {
    margin-top: 35px;
    text-align: center;

    .el-button {
        padding-left: 40px;
        padding-right: 40px;
    }
}

.fileBox {
    display: flex;

    .fileTitle {
        margin-right: 10px;
    }

    .fileItem {
        display: flex;
        flex-direction: column;

        >div {
            color: #3984f7;
        }
    }
}

.connectClass {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;
    height: 300px;
    padding-bottom: 20px;
    margin-bottom: 20px;

    /* background: red; */

    .father:after {
        content: "";
        display: block;
        height: 0;
        clear: both;
        visibility: hidden;
    }

    .father {
        zoom: 1;
        /*IE6清除浮动的方式 只有IE6-IE7执行，其他浏览器不执行*/
    }

    .connectItem {
        overflow: hidden;
        width: 100%;

        .backgroundEdeded {
            background: #ededed !important;
        }

        .infoClass {
            background: #94eb6c;
            display: inline-block;
            width: auto;
            max-width: 40%;
            padding: 10px;
            border-radius: 10px;
        }
    }
}
</style>
